import { Component } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { FaIconComponent } from '@fortawesome/angular-fontawesome'

import { BonusTableYearlyVariable, RepositoryModal } from '../../../shared'

@Component({
    templateUrl: './bonus-table-yearly-variable.component.html',
    standalone: true,
    imports: [FormsModule, FaIconComponent],
})
export class BonusTableYearlyVariableComponent extends RepositoryModal<BonusTableYearlyVariable> {}
